import { useEffect } from 'react'
import ReactDOM from 'react-dom'
import { animateScroll as scroll } from 'react-scroll'

type ScrollConfig = {
  duration: number
  delay: number
  smooth: string
}

const DEFAULT_SCROLL_CONFIG: ScrollConfig = {
  duration: 1200,
  delay: 200,
  smooth: 'easeOutQuart',
}

export const useScrollIntoView = (
  ref: React.MutableRefObject<HTMLInputElement | undefined>,
  hasLoaded: boolean,
) => {
  const yCord =
    (ReactDOM.findDOMNode(ref?.current) as Element)?.getBoundingClientRect()
      .top - 150
  useEffect(() => {
    if (ref.current) {
      const distance: number = yCord

      scroll.scrollTo(distance, DEFAULT_SCROLL_CONFIG)
    }
  }, [hasLoaded])
}
